// NorthStar Customs V1 site script (pixel_version "customs-v1"). Built per brand by build.mjs (this folder); do not edit the per-brand files by hand.
// Brand: FK Floatie Kings (floatiekings.com)
//
// Install ONCE per site. Nothing channel-specific is baked in: every click id and ad cookie is captured now, even for
// channels not yet connected, and Google, Microsoft/Bing, Meta, Klaviyo, TikTok and LinkedIn tie-ins happen server-side
// from the stored events. New event types or fields are switched on through the remote config, not a reinstall.
//
// What it does, on every page of the brand's site:
//   1. Keeps one visitor id (cookie _ns_vid, shared with the NorthStar Shopify pixel) and a 30-minute session id.
//   2. Captures click ids (gclid, gbraid, wbraid, dclid, fbclid, msclkid, ttclid, li_fat_id, epik, ScCid, twclid, rdt_cid,
//      _kx, irclickid), all UTMs (including utm_id), the landing URL and the referrer, as a FIRST touch (kept once) and a
//      LAST touch (replaced by every new campaign click). Ad cookies (_gcl_aw, _fbp, _fbc, _uetmsclkid, _uetsid, _uetvid,
//      _ttp, _scid, _epik, _kla_id, _rdt_cid, _twclid, li_fat_id) are sent as evidence with every event.
//   3. Sends events: page_viewed, quote_viewed, form_started, form_submitted, phone_click, email_click, chat_started.
//   4. Adds hidden NorthStar inputs to a quote form, ONLY when it is provably safe (see SAFETY below).
//   5. Reads the remote config (GET on the collector, cached 10 minutes, applied live when it arrives): events_off,
//      extra_params, extra_cookies, disabled (all brands) and brands.<CODE>.disabled / inject_forms / survey_enabled /
//      cross_site_links.
//   6. Survey (brands.<CODE>.survey_enabled, seeded ON, off if the row or config read fails): window.NorthStarCustoms.surveyEnabled() and
//      window.NorthStarCustoms.survey({answer, other, entryId}) send one survey_answered event for the site's own
//      "how did you hear about us" question. The script never renders or reads the question.
//   7. Cross-site visitor link (brands.<CODE>.cross_site_links, seeded ON, off if the row or config read fails): a click on a link to one of the other three
//      brand domains gets ns_xv=<visitorId>.<brand> appended to that link. On landing with a valid ns_xv the script sends
//      cross_site_arrival (fromVisitorId, fromBrand) and removes ns_xv from the address bar. This site's own _ns_vid is
//      never overwritten.
//
// SAFETY (Michael: never break a Customs site or a Wufoo form):
//   - Every entry point (start, listeners, timers, fetch) is wrapped; any error is swallowed silently, no console output.
//   - Never preventDefault, stopPropagation or returns false; never awaits before a submit. Never changes, renames or
//     removes an existing field. The only page change is ADDING hidden inputs, and only when every check passes.
//   - Wufoo form: injects only when all four Field numbers are real digits, distinct, and no element in the form already
//     has any of those names. A placeholder or unknown number injects nothing. Never guesses a Field<N>.
//   - Floatie Kings form (posts to fk-chat-leads-api): injection is OFF unless the remote config sets
//     brands.FK.inject_forms = true. Visit and click tracking stays on.
//   - Kill switch: remote config disabled (or brands.<CODE>.disabled) makes the script a no-op, no reinstall.
//     A missing or failed config keeps the safe defaults.
//   - Heavy work is deferred off the parse path; no DOM observers, no loops over the page; network is sendBeacon or
//     keepalive fetch with a 4 second timeout. One global only: window.NorthStarCustoms.
/* global AbortController */
(function () {
  "use strict";
  var BRAND = "FK";
  var PIXEL_VERSION = "customs-v1";
  var ENDPOINT = "https://customs.curvgroup.com/api/webhooks/northstar/collect?source=fk_ns_294648647d62df9039c43e2b9ddfbf3f";
  // Wufoo field numbers of the four hidden fields (NS Visitor, NS Clicks, NS First, NS Last), per form hash.
  // The build fills the numbers Shamil sends back (set-wufoo-fields.mjs). Until then the values are placeholders and a
  // Wufoo form is tracked but never touched.
  var WUFOO_FIELDS = {};
  // The one non-Wufoo form the script may ever add inputs to (the Floatie Kings quote widget), and only with
  // brands.<CODE>.inject_forms = true in the remote config.
  var OWN_FORM_SELECTOR = "#quote-widget form";
  // The four Customs sites. ns_xv links go only to the other three.
  var SITES = { FK: "floatiekings.com", CI: "custominflatables.com", COM: "custompoolfloats.com", CCM: "createcustommolds.com" };
  var SURVEY_ANSWERS = ["google_search", "trade_show", "referral", "repeat_customer", "facebook_instagram", "youtube", "linkedin", "other"];
  var SURVEY_OTHER_MAX = 100;
  var XV_PARAM = "ns_xv";
  var XV_PATTERN = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\.(FK|CI|COM|CCM)$/;
  var ENTRY_ID_PATTERN = /^[A-Za-z0-9._:-]{1,128}$/;

  var NS = { version: PIXEL_VERSION, brand: BRAND, off: false, injectForms: false, started: false, surveyOn: false, crossLinks: false };
  try {
    if (window.NorthStarCustoms) return; // installed twice: the first copy runs, this one stays silent
    window.NorthStarCustoms = NS;
  } catch (e) { return; }

  var CLICK_PARAMS = {
    gclid: "gclid", gbraid: "gbraid", wbraid: "wbraid", dclid: "dclid", fbclid: "fbclid", msclkid: "msclkid", ttclid: "ttclid",
    li_fat_id: "li_fat_id", epik: "epik", ScCid: "sccid", sccid: "sccid", twclid: "twclid", rdt_cid: "rdt_cid", _kx: "klaviyo_kx", irclickid: "irclickid"
  };
  var CLICK_KEYS = ["gclid", "gbraid", "wbraid", "dclid", "fbclid", "msclkid", "ttclid", "li_fat_id", "epik", "sccid", "twclid", "rdt_cid", "klaviyo_kx", "irclickid"];
  var UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id"];
  var COOKIES = ["_gcl_aw", "_gcl_au", "_gcl_dc", "_fbp", "_fbc", "_uetmsclkid", "_uetsid", "_uetvid", "_ttp", "_scid", "_epik", "_kla_id", "_rdt_cid", "_twclid", "li_fat_id"];
  var NS_KEYS = ["visitor", "clicks", "first", "last"];
  var FIRST_KEY = "ns_customs_first_v1";
  var LAST_KEY = "ns_customs_last_v1";
  var SESSION_KEY = "ns_customs_session_v1";
  var CONFIG_KEY = "ns_customs_config_v2";
  var SESSION_MS = 30 * 60 * 1000;
  var CONFIG_MS = 10 * 60 * 1000;
  var NET_TIMEOUT_MS = 4000;
  var CLICK_PATTERN = /^[A-Za-z0-9._~:+\/=%-]{1,2048}$/;

  function uuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    } catch (e) { /* fall through */ }
    var b = [];
    for (var i = 0; i < 16; i++) b.push(Math.floor(Math.random() * 256));
    try { if (window.crypto && window.crypto.getRandomValues) { var u = new Uint8Array(16); window.crypto.getRandomValues(u); b = Array.prototype.slice.call(u); } } catch (e) { /* Math.random bytes */ }
    b[6] = (b[6] & 15) | 64;
    b[8] = (b[8] & 63) | 128;
    var h = b.map(function (x) { return (x + 256).toString(16).slice(1); }).join("");
    return h.slice(0, 8) + "-" + h.slice(8, 12) + "-" + h.slice(12, 16) + "-" + h.slice(16, 20) + "-" + h.slice(20);
  }
  function readCookie(name) {
    try {
      var parts = document.cookie ? document.cookie.split("; ") : [];
      for (var i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf("=");
        if (parts[i].slice(0, eq) === name) {
          try { return decodeURIComponent(parts[i].slice(eq + 1)); } catch (e) { return parts[i].slice(eq + 1); }
        }
      }
    } catch (e) { /* cookies blocked */ }
    return "";
  }
  function rootDomain() {
    var host = location.hostname.split(".");
    return host.length > 2 ? host.slice(-2).join(".") : location.hostname;
  }
  function store(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage blocked */ }
  }
  function load(key) {
    try { return JSON.parse(localStorage.getItem(key) || "null"); } catch (e) { return null; }
  }
  function cleanId(v) { return v && CLICK_PATTERN.test(v) ? v : ""; }
  function listOf(v) { return Object.prototype.toString.call(v) === "[object Array]" ? v : []; }
  function safe(fn) {
    return function () { try { return fn.apply(this, arguments); } catch (e) { return undefined; } };
  }
  function later(fn, ms) {
    try { return setTimeout(safe(fn), ms || 0); } catch (e) { return 0; }
  }

  // ---- Remote config (kill switch and switches). Missing or failed config keeps the safe defaults. ----
  var eventsOff = [];
  var extraParams = [];
  var extraCookies = [];
  function applyConfig(v2) {
    if (!v2 || typeof v2 !== "object") return;
    var b = v2.brands && typeof v2.brands === "object" && v2.brands[BRAND] && typeof v2.brands[BRAND] === "object" ? v2.brands[BRAND] : {};
    if (v2.disabled === true || b.disabled === true) NS.off = true;
    NS.injectForms = b.inject_forms === true;
    NS.surveyOn = b.survey_enabled === true;
    NS.crossLinks = b.cross_site_links === true;
    NS.wufooOff = b.inject_forms === false;
    eventsOff = listOf(v2.events_off || v2.disabled_events).filter(function (p) { return typeof p === "string"; }).slice(0, 40);
    extraParams = listOf(v2.extra_params).filter(function (p) { return typeof p === "string" && /^[A-Za-z0-9_.-]{1,64}$/.test(p); }).slice(0, 40);
    extraCookies = listOf(v2.extra_cookies || v2.cookie_names).filter(function (p) { return typeof p === "string" && /^[A-Za-z0-9_.-]{1,64}$/.test(p); }).slice(0, 20);
  }
  function fetchConfig() {
    if (typeof fetch !== "function") return;
    var ctrl = null;
    try { ctrl = typeof AbortController === "function" ? new AbortController() : null; } catch (e) { ctrl = null; }
    if (ctrl) later(function () { ctrl.abort(); }, NET_TIMEOUT_MS);
    var opts = { method: "GET", mode: "cors", credentials: "omit" };
    if (ctrl) opts.signal = ctrl.signal;
    fetch(ENDPOINT, opts).then(function (r) { return r && r.ok ? r.json() : null; }).then(function (body) {
      try {
        if (!body || typeof body !== "object" || !body.curv_ns_config_v2 || typeof body.curv_ns_config_v2 !== "object") return;
        store(CONFIG_KEY, { at: Date.now(), v2: body.curv_ns_config_v2 });
        applyConfig(body.curv_ns_config_v2); // live: a kill switch stops this page too
        handleArrival();
      } catch (e) { /* config is optional */ }
    }).catch(function () { /* config is optional */ });
  }

  // ---- State, built once by start() (deferred) or on demand by the first listener that needs it. ----
  var S = null;
  function start() {
    if (S || NS.off) return S;
    var now = Date.now();
    var visitorId = readCookie("_ns_vid");
    if (!/^[0-9a-f-]{36}$/i.test(visitorId)) visitorId = uuid();
    try { document.cookie = "_ns_vid=" + visitorId + "; path=/; domain=." + rootDomain() + "; max-age=" + (400 * 24 * 60 * 60) + "; SameSite=Lax; Secure"; } catch (e) { /* cookie blocked */ }
    var session = load(SESSION_KEY);
    if (!session || !session.id || typeof session.at !== "number" || now - session.at > SESSION_MS) session = { id: uuid(), at: now };
    session.at = now;
    store(SESSION_KEY, session);

    var params = typeof URLSearchParams === "function" ? new URLSearchParams(location.search) : { get: function () { return null; } };
    var touch = { ts: new Date(now).toISOString(), landing: location.pathname + location.search, ref: document.referrer || "" };
    var hasCampaign = false;
    Object.keys(CLICK_PARAMS).forEach(function (param) {
      var v = String(params.get(param) || "").trim();
      if (v && CLICK_PATTERN.test(v)) { touch[CLICK_PARAMS[param]] = v; hasCampaign = true; }
    });
    UTM_PARAMS.forEach(function (param) {
      var v = String(params.get(param) || "").trim().slice(0, 200);
      if (v) { touch[param] = v; hasCampaign = true; }
    });
    extraParams.forEach(function (param) {
      var v = String(params.get(param) || "").trim().slice(0, 200);
      if (v) { touch["x_" + param] = v; hasCampaign = true; }
    });
    var cookies = {};
    COOKIES.concat(extraCookies).forEach(function (name) {
      var v = cleanId(readCookie(name));
      if (v) cookies[name] = v;
    });
    var fbc = cookies._fbc || (touch.fbclid ? "fb.1." + now + "." + touch.fbclid : "");
    if (!touch.li_fat_id && cookies.li_fat_id) touch.li_fat_id = cookies.li_fat_id;
    if (!touch.msclkid && cookies._uetmsclkid && cookies._uetmsclkid.indexOf("_uet") === 0) touch.msclkid = cookies._uetmsclkid.slice(4);
    var first = load(FIRST_KEY);
    if (!first || typeof first !== "object") { first = touch; store(FIRST_KEY, first); }
    var last = load(LAST_KEY);
    if (!last || typeof last !== "object" || hasCampaign) { last = touch; store(LAST_KEY, last); }
    var clicks = {};
    CLICK_KEYS.forEach(function (k) { clicks[k] = last[k] || first[k] || ""; });
    Object.keys(cookies).forEach(function (name) { clicks[name.replace(/^_/, "")] = cookies[name]; });
    clicks.fbc = fbc;
    S = { visitorId: visitorId, session: session, touch: touch, cookies: cookies, fbc: fbc, first: first, last: last,
      values: { visitor: visitorId, clicks: qs(clicks), first: qs(first), last: qs(last) } };
    NS.started = true;
    return S;
  }
  function qs(obj) {
    var out = [];
    Object.keys(obj).forEach(function (k) { if (obj[k] && typeof obj[k] !== "object") out.push(encodeURIComponent(k) + "=" + encodeURIComponent(String(obj[k]))); });
    return out.join("&");
  }

  function send(type, formRef, extra) {
    if (NS.off || eventsOff.indexOf(type) >= 0) return false;
    var s = start();
    if (!s) return false;
    var utm = {};
    UTM_PARAMS.forEach(function (p) { if (s.touch[p]) utm[p.replace("utm_", "")] = s.touch[p]; });
    var ids = {};
    CLICK_KEYS.forEach(function (k) { if (s.touch[k]) ids[k] = s.touch[k]; });
    if (s.cookies._fbp) ids.fbp = s.cookies._fbp;
    if (s.fbc) ids.fbc = s.fbc;
    var event = {
      eventId: uuid(), eventType: type, occurredAt: new Date().toISOString(), visitorId: s.visitorId, sessionId: s.session.id,
      path: location.pathname || "/", landingUrl: (location.pathname + location.search).slice(0, 4096),
      pageUrl: location.href.slice(0, 4096), referrerUrl: document.referrer ? document.referrer.slice(0, 4096) : undefined,
      utm: utm, clickIds: ids, formRef: formRef, evidence: { cookies: s.cookies, first: s.first, last: s.last },
      pixelVersion: PIXEL_VERSION, pixel_version: PIXEL_VERSION, brand: BRAND
    };
    if (extra) Object.keys(extra).forEach(function (k) { if (extra[k]) event[k] = extra[k]; });
    var body = JSON.stringify({ pixelKind: "site_script", pixelVersion: PIXEL_VERSION, pixel_version: PIXEL_VERSION, brand: BRAND, events: [event] });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }))) return true;
    } catch (e) { /* fall through to fetch */ }
    try {
      if (typeof fetch !== "function") return false;
      var p = fetch(ENDPOINT, { method: "POST", body: body, keepalive: true, mode: "cors", credentials: "omit", headers: { "Content-Type": "text/plain" } });
      if (p && typeof p.catch === "function") p.catch(function () { /* tracking never breaks the page */ });
      return true;
    } catch (e) { /* tracking never breaks the page */ }
    return false;
  }

  // ---- Survey. The site's own question calls this; the script never renders or reads a form. ----
  NS.surveyEnabled = function () {
    try { return NS.surveyOn === true && NS.off !== true; } catch (e) { return false; }
  };
  NS.survey = function (input) {
    try {
      if (!NS.surveyEnabled() || !input || typeof input !== "object") return false;
      var answer = typeof input.answer === "string" ? input.answer : "";
      if (SURVEY_ANSWERS.indexOf(answer) < 0) return false;
      var extra = { answer: answer, timestamp: new Date().toISOString() };
      if (answer === "other" && typeof input.other === "string") {
        var other = input.other.replace(/^\s+|\s+$/g, "").slice(0, SURVEY_OTHER_MAX).replace(/\s+$/g, "");
        if (other) extra.other = other;
      }
      var entry = input.entryId === undefined || input.entryId === null ? "" : String(input.entryId).replace(/^\s+|\s+$/g, "");
      if (entry && ENTRY_ID_PATTERN.test(entry)) extra.entryId = entry;
      return send("survey_answered", undefined, extra) === true;
    } catch (e) { return false; }
  };

  // ---- Cross-site visitor link: ns_xv=<visitorId>.<brand> on links to the other three brand sites. ----
  function otherSite(host) {
    host = String(host || "").toLowerCase();
    for (var code in SITES) {
      if (code === BRAND || !Object.prototype.hasOwnProperty.call(SITES, code)) continue;
      if (host === SITES[code] || host.slice(-(SITES[code].length + 1)) === "." + SITES[code]) return code;
    }
    return "";
  }
  function linkVisitor(anchor) {
    if (NS.off || !NS.crossLinks || !anchor || !anchor.getAttribute) return;
    var raw = String(anchor.getAttribute("href") || "");
    if (!raw || raw.charAt(0) === "#" || /^(mailto|tel|javascript):/i.test(raw)) return;
    var url = new URL(raw, location.href);
    if ((url.protocol !== "https:" && url.protocol !== "http:") || !otherSite(url.hostname)) return;
    if (url.search.indexOf(XV_PARAM + "=") >= 0 || url.search.indexOf("&" + XV_PARAM) >= 0) return;
    var s = start();
    if (!s) return;
    var value = s.visitorId + "." + BRAND;
    if (!XV_PATTERN.test(value)) return;
    var hash = url.hash;
    var base = url.href.slice(0, url.href.length - hash.length);
    anchor.setAttribute("href", base + (base.indexOf("?") >= 0 ? (/[?&]$/.test(base) ? "" : "&") : "?") + XV_PARAM + "=" + value + hash);
  }
  var arrivalChecked = false;
  var arrivalSent = false;
  var arrivalPending = null;
  // On landing with ns_xv: always remove it from the address bar (valid or not), before anything reads the URL. Record a
  // cross_site_arrival only for a valid value, only when cross_site_links is on (it waits for the config if that is late).
  function handleArrival() {
    if (NS.off) return;
    if (!arrivalChecked) {
      arrivalChecked = true;
      var search = String(location.search || "");
      if (search.indexOf(XV_PARAM + "=") >= 0) {
        var kept = [];
        var value = "";
        search.replace(/^\?/, "").split("&").forEach(function (part) {
          if (part.slice(0, XV_PARAM.length + 1) === XV_PARAM + "=") { if (!value) value = part.slice(XV_PARAM.length + 1); } else if (part) kept.push(part);
        });
        try { history.replaceState(history.state, "", location.pathname + (kept.length ? "?" + kept.join("&") : "") + location.hash); } catch (e) { /* address bar left as is */ }
        var m = value.length <= 45 ? XV_PATTERN.exec(value) : null;
        if (m && m[2] !== BRAND) arrivalPending = { id: m[1].toLowerCase(), brand: m[2] };
      }
    }
    if (arrivalPending && NS.crossLinks && !arrivalSent) {
      arrivalSent = true;
      send("cross_site_arrival", undefined, { fromVisitorId: arrivalPending.id, fromBrand: arrivalPending.brand });
    }
  }

  // ---- Form filling: ADD hidden inputs only, never touch an existing field. ----
  function wufooHash(form) {
    var m = String(form.getAttribute("action") || "").match(/wufoo\.com\/forms\/([a-z0-9]+)/i);
    return m ? m[1] : "";
  }
  function hasName(form, name) {
    try { if (form.elements && form.elements.namedItem && form.elements.namedItem(name)) return true; } catch (e) { return true; }
    try { if (form.querySelector("[name='" + name + "']")) return true; } catch (e) { return true; }
    try { if (form.id && document.querySelector("[form='" + form.id.replace(/'/g, "") + "'][name='" + name + "']")) return true; } catch (e) { return true; }
    return false;
  }
  function addHidden(form, name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    input.setAttribute("data-ns", "1");
    form.appendChild(input);
  }
  // Returns the four Field names for this Wufoo form, or null unless every one is a real, distinct, unused number.
  function wufooNames(form, hash) {
    var map = WUFOO_FIELDS[hash];
    if (!map || typeof map !== "object") return null;
    var names = [];
    for (var i = 0; i < NS_KEYS.length; i++) {
      var n = String(map[NS_KEYS[i]] || "");
      if (!/^[1-9][0-9]{0,5}$/.test(n)) return null; // placeholder or unknown: inject NOTHING
      if (names.indexOf("Field" + n) >= 0) return null;
      names.push("Field" + n);
    }
    return names;
  }
  function fillForm(form) {
    if (NS.off || !form || !form.querySelector || form.getAttribute("data-ns-done")) return;
    var hash = wufooHash(form);
    var names;
    if (hash) {
      if (NS.wufooOff) return;
      names = wufooNames(form, hash);
      if (!names) return;
    } else {
      if (!NS.injectForms) return;
      var ok = false;
      try { ok = !!(form.matches && form.matches(OWN_FORM_SELECTOR)); } catch (e) { ok = false; }
      if (!ok) return;
      names = ["ns_visitor", "ns_clicks", "ns_first", "ns_last"];
    }
    // Any existing element with one of these names means the mapping is wrong or someone else owns it: skip the form.
    for (var i = 0; i < names.length; i++) if (hasName(form, names[i])) return;
    var s = start();
    if (!s) return;
    for (var j = 0; j < names.length; j++) if (s.values[NS_KEYS[j]]) addHidden(form, names[j], s.values[NS_KEYS[j]]);
    form.setAttribute("data-ns-done", "1");
  }

  function isSearchOrCart(form) {
    var action = String(form.getAttribute("action") || "").toLowerCase();
    return action.indexOf("/search") === 0 || action.indexOf("/cart") === 0;
  }

  // ---- Listeners: passive observers, capture phase, never cancel or delay anything. ----
  var started = {};
  try {
    document.addEventListener("focusin", safe(function (e) {
      if (NS.off) return;
      var form = e.target && e.target.form;
      if (!form || !form.getAttribute || isSearchOrCart(form)) return;
      var ref = String(form.getAttribute("id") || form.getAttribute("action") || "form").slice(0, 256);
      fillForm(form);
      if (started[ref]) return;
      started[ref] = 1;
      send("form_started", ref);
    }), true);
    document.addEventListener("submit", safe(function (e) {
      if (NS.off) return;
      var form = e.target;
      if (!form || !form.getAttribute || isSearchOrCart(form)) return;
      try { fillForm(form); } catch (err) { /* the submit goes ahead untouched */ }
      // ONE event per submit. "lead" is a server-side classification of form_submitted, never a second client event.
      var hash = wufooHash(form);
      send("form_submitted", String(hash || form.getAttribute("id") || form.getAttribute("action") || "form").slice(0, 256), { formId: String(form.getAttribute("id") || "").slice(0, 128), formHash: hash });
    }), true);
    document.addEventListener("click", safe(function (e) {
      if (NS.off) return;
      var node = e.target;
      for (var depth = 0; node && node !== document && depth < 8; depth++) {
        var href = node.getAttribute ? String(node.getAttribute("href") || "") : "";
        if (/^tel:/i.test(href)) { send("phone_click", href.slice(0, 64)); return; }
        if (/^mailto:/i.test(href)) { send("email_click", href.replace(/\?.*$/, "").slice(0, 128)); return; }
        var cls = node.className && typeof node.className === "string" ? node.className : "";
        var marker = node.getAttribute ? ((node.id || "") + " " + cls + " " + (node.getAttribute("aria-label") || "")) : "";
        if (/chat[-_ ]?(button|launcher|open|widget|trigger|toggle|bubble)|shopify-chat|tidio|intercom-launcher|gorgias-chat|open chat/i.test(marker)) { send("chat_started", "click"); return; }
        node = node.parentNode;
      }
    }), true);
    // Cross-site link: set the ns_xv parameter just before the browser follows the link. Never cancels or delays the click.
    var onLinkClick = safe(function (e) {
      if (NS.off || !NS.crossLinks) return;
      var node = e.target;
      for (var depth = 0; node && node !== document && depth < 8; depth++) {
        if (node.tagName === "A" && node.getAttribute && node.getAttribute("href")) { linkVisitor(node); return; }
        node = node.parentNode;
      }
    });
    document.addEventListener("click", onLinkClick, true);
    document.addEventListener("auxclick", onLinkClick, true);
  } catch (e) { /* listeners are optional */ }

  // ---- Boot, off the parse path. ----
  safe(function () {
    var cached = load(CONFIG_KEY);
    if (cached && cached.v2) applyConfig(cached.v2);
    if (!cached || typeof cached.at !== "number" || Date.now() - cached.at > CONFIG_MS) later(fetchConfig, 0);
  })();
  later(function () {
    if (NS.off) return;
    handleArrival();
    start();
    send("page_viewed");
    if (/quote|contact|get-a-quote|request|estimate/i.test(location.pathname + location.search)) send("quote_viewed");
  }, 0);
})();
